import React from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormCreateSideItem = ({ handleCreateSideItem }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    // Convert price to number
    const formattedData = {
      ...data,
      extra_price: parseFloat(data.extra_price),
    };
    handleCreateSideItem(formattedData);
  };

  return (
    <div className="container">
      <div className="cheese-form-container mx-auto">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="mb-3">
            <label className="form-label">Nombre del extra</label>
            <input
              type="text"
              className={`form-control ${
                errors.addon_name ? "is-invalid" : ""
              }`}
              placeholder="Ejemplo: Extra grande, Extra mediano, etc."
              {...register("addon_name", {
                required: "Este campo es obligatorio",
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.addon_name?.message || ""}
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Precio extra</label>
            <input
              type="number"
              step="0.01"
              min="0"
              className={`form-control ${
                errors.extra_price ? "is-invalid" : ""
              }`}
              placeholder="Ejemplo: 150.00"
              {...register("extra_price", {
                required: "Este campo es obligatorio",
                min: {
                  value: 0,
                  message: "El precio debe ser mayor a 0",
                },
              })}
            />
            <div className="invalid-feedback" style={{ minHeight: "20px" }}>
              {errors.extra_price?.message || ""}
            </div>
          </div>

          <button type="submit" className="btn products-btn w-100">
            Crear Extra
          </button>
        </form>
      </div>
    </div>
  );
};

export default FormCreateSideItem;
